/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class DataErrorKey {
  static readonly ENTITY_NOT_FOUND = 'kit-data/error/entity-not-found';
  static readonly ENTITY_AMBIGUOUS = 'kit-data/error/entity-ambiguous';
  static readonly ENTITY_MODIFIED = 'kit-data/error/entity-modified';
  static readonly ENTITY_LOAD_ERROR = 'kit-data/error/entity-load-error';
  static readonly ENTITY_INSERT_ERROR = 'kit-data/error/entity-insert-error';
  static readonly ENTITY_UPDATE_ERROR = 'kit-data/error/entity-update-error';
  static readonly ENTITY_DELETE_ERROR = 'kit-data/error/entity-delete-error';
  static readonly ENTITY_ID_MISSING = 'kit-data/error/entity-id-missing';
  static readonly ENTITY_ID_INCOMPLETE = 'kit-data/error/entity-id-incomplete';
}
